<template>
    <guide-page v-bind:config="pageConfig" :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :shareHaderName="shareHaderName"></guide-page>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuidePage from '../component/GuidePage.vue';

export default {
  name: 'BindWeChat',
  components: {
    guidePage: GuidePage,
  },
  data() {
    return {
      wxaPage: 'pages/me/guide/guide-page/guide-page',
      wxaPageParam: 'key=4',
      shareHaderName: '转发商品',
      pageConfig: {
        sections: [
          {
            head: {
              title: '转发商品给顾客（店员操作）',
              tips: '* 顾客端仅展示商品的基本信息及店铺信息，不展示商品价格',
            },
            steps: [
              {
                description: [
                  '点击「目的地」, 选择要办理的国家, 点击进入；选择相应的产品, 点击进入下一级页面；',
                ],
                sub: [
                  {
                    images: [{ name: '4_01' }],
                  },
                ],
              },
              {
                description: [
                  '签证详情页可查看不同身份人员所需的签证资料；',
                  '点击右上角分享可将商品转发给顾客，由顾客自主下单；',
                  '点击「商品二维码」弹出商品二维码，可以扫描二维码进行办理。',
                ],
                sub: [
                  {
                    images: [{ name: '4_02' }],
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '转发商品',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/guide/sub/ForwardGoods.vue